import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const Download = (props: Icon): React.ReactElement => {
  if (props.variant === "line") {
    return (
      <svg
        viewBox="0 0 24 22"
        style={{ ...style(props.size, props.height), ...props.style }}
        className={props.className}
      >
        <g
          stroke={props.color || theme.palette.grey600}
          strokeWidth={2}
          fill="none"
          fillRule="evenodd"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M8 1H3L1 14v5a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2v-5L21 1h-5m3 13h4M1 14h4" />
          <path d="M16 12l-4 4-4-4m4-11v15" />
        </g>
      </svg>
    );
  }

  return (
    <svg
      viewBox="0 0 24 22"
      style={{ ...style(props.size, props.height), ...props.style }}
      className={props.className}
    >
      <path
        d="M15.001 8.001h-2v-2a1 1 0 0 0-2 0v2h-2a.999.999 0 0
        0-.707 1.707l3.707 3.707 3.707-3.707a.999.999 0 0
        0-.707-1.707zm7.082-6.309A1.999 1.999 0 0 0 20.108.001H3.895c-.985
        0-1.824.718-1.975 1.691L.001 14.001v6.001c0 1.104.895 1.999 1.999
        1.999h20.001A1.999 1.999 0 0 0 24 20.002v-6.001L22.083 1.692zm-7.082
        12.309a3 3 0 1 1-6 0H3.037l1.714-11H19.25l1.714 11h-5.963z"
        fill={props.color || theme.palette.grey600}
        fillRule="nonzero"
      />
    </svg>
  );
};
